<template>
	<div>
		<div v-if="formCreateInject">
			<template v-if="mount">
				<div class="flex" style="width: 100%;position: relative;flex-direction: row;align-items: center;">
					<van-field @click="preview" :required="formCreateInject.rule.validate[0].required" :value="value"
						readonly :label="formCreateInject.prop.title.title" placeholder="" input-align="right"
						:class="{penetrate:penetrate}">
						<template #left-icon>
							<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
						</template>
					</van-field>
					<box :readonly="readonly" :disabled="disabled" :ref="boxRef" :title="button.props.title"
						:index="button.props.index" :group="button.props.group" :width="button.props.width"
						:moduleName="button.props.moduleName" @submit="submit" :store="store" code="0"
						:popoverDisabled="true" />
				</div>
			</template>
			<template v-if="!mount">
				<div v-if="penetrate">
					<van-field @click="preview" :required="formCreateInject.rule.validate[0].required" :value="value"
						readonly :label="formCreateInject.prop.title.title" placeholder="" input-align="right"
						:class="{penetrate:penetrate}">
					</van-field>
				</div>
				<template v-else>
					<van-field :type="inputprops.type" :required="formCreateInject.rule.validate[0].required"
						:value="value" :label="formCreateInject.prop.title.title" :readonly="readonly"
						:disabled="disabled" input-align="right" @input="change">
					</van-field>
				</template>
			</template>
		</div>
		<div v-else>
			<div v-if="!penetrate">{{value}}</div>
			<div v-else @click="preview" style="color: #409EFF;">{{value}}</div>
		</div>
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
			v-if="penetrateComponentConfig" />
	</div>
</template>

<script>
	import Store from '@/store/store.js'
	import router from '@_system/router'
	import inputBase from '@_system/components/base/input.js'
	import box from '@_system/components/formcomponents/phone/box/index.vue'
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	export default {
		mixins: [inputBase,penetrate],
		props: {
			$router: {
				type: Object,
				default: () => {
					return router
				}
			},
			inputprops: {
				default: () => {
					return {
						type: 'text',
						rows: 2
					}
				}
			},
			renderOpts: {
				type: Object,
				default: () => {
					return null
				}
			},
			quote: {
				type: String,
				default: () => {
					return null
				}
			},
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			bindField: {
				type: String,
				default: () => {
					return ''
				}
			},
			penetrate: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			penetrateModule: {
				type: Object,
				default: () => {
					return null
				}
			},
			penetrateComponent: {
				type: Object,
				default: () => {
					return null
				}
			},
			mount: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			readonly: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			sourceModuleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			button: {
				type: Object,
				default: () => {
					return null
				}
			},
			fieldsource: {
				type: String,
				default: () => {
					return ''
				}
			},
			islist: {
				type: Boolean,
				default: () => {
					return false
				}
			},


		},
		data() {
			return {
				device: window.systemMethods.device(),
				refreshing: false,
				store: {},
				boxRef: 'box_' + Math.random(),
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 3,
					foreingKey: {},
					extra: {},

				},
				formwindowShow: false,
				windowType: 'window',
				win: null,
				penetrateComponentConfig: null
			}
		},
		created() {

		},
		mounted() {
			this.store.input = this
			if (!this.islist && !this.$store) {
				this.$store = Store.store
			}
			// console.log(this.formCreateInject,this.value)
		},
		watch: {
			value(e) {
				this.change(e)
			}
		},
		computed: {

		},
		methods: {
			getBox() {
				return this.$refs[this.boxRef]
			},
			submit(e) {
				e.formCreateInject = this.formCreateInject
				this.$emit('submit', e)
			},
			refresh(type) {

				this.refreshing = true
				if (type == 'main') {
					let box = this.$refs[this.boxRef]
					let page = {
						pageSize: 20,
						currentPage: 1
					}
					let form = {}
					form[this.quote] = this.value
					box.list(page, form).then((res) => {
						if (res.list.length != 0) {
							box.submitwidthreflash(res.list[0])
							this.change(this.value)
						} else {
							this.$message.error('刷新失败，未查询到数据')
						}
						this.refreshing = false
					})
				} else {
					new Promise((resolve) => {
						this.$emit('buttonclick', {
							resolve: resolve
						})
					}).then(() => {
						this.refreshing = false
						this.change(this.value)
					})


				}


			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
			},
			formBack() {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
				}
			},
		},
		components: {
			box
		}
	}
</script>
